/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */

import { CdkDrag } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { AppService } from '@services';
import { AngularSvgIconModule } from 'angular-svg-icon';

type Log = {
  messages: string[];
  args?: string;
  type: 'log' | 'warn' | 'error';
};

@Component({
  selector: 'bo-console',
  templateUrl: './console.component.html',
  standalone: true,
  imports: [AngularSvgIconModule, CommonModule, CdkDrag],
})
export class ConsoleComponent implements OnInit {
  protected appService = inject(AppService);

  logs = signal<Log[]>([{ messages: ['Console started...'], type: 'log' }]);

  showConsole = this.appService.showConsole;

  ngOnInit(): void {
    if (window.console && console.log) {
      const cl = console.log;
      console.log = function (...args) {
        const messages = args.map((arg) =>
          Array.isArray(arg) ? '[' + arg + ']' : arg,
        );
        setLog(messages);
        cl.apply(this, arguments as any);
      };
    }

    const setLog = (message: string[]) => {
      this.logs.set([{ messages: message, type: 'log' }, ...this.logs()]);
    };

    if (window.console && console.warn) {
      const cl = console.warn;
      console.warn = function (message, args) {
        setWarnLog(message, args);
        cl.apply(this, arguments as any);
      };
    }

    const setWarnLog = (message: string, args: string) => {
      this.logs.set([
        {
          messages: [message],
          args,
          type: 'warn',
        },
        ...this.logs(),
      ]);
    };

    if (window.console && console.error) {
      const cl = console.error;
      console.error = function (message, args) {
        setErrorLog(message, args);
        cl.apply(this, arguments as any);
      };
    }

    const setErrorLog = (message: string, args: string) => {
      this.logs.set([
        {
          messages: [message],
          args,
          type: 'error',
        },
        ...this.logs(),
      ]);
    };
  }
}
